// extracted by mini-css-extract-plugin
export var copyrightSection = "copyright-section-module--copyright-section--1vU9j";
export var footerDark = "copyright-section-module--footer-dark--3fltF";